@if ((globalError$ | async); as payload) {
  <app-modal [display]="errorDisplay">
    <app-modal-body>
      @if (payload.message.icon === 'fail') {
        <div class="has-margin-bottom-normal">
          <app-warning-icon></app-warning-icon>
        </div>
      } @else {
        <app-icon [name]="payload.message.icon"
          class="is-flex is-justify-center text-red-alert text-32 is-large"
          />
      }
      <el-heading [text]="payload.message.title"
        class="is-flex is-justify-center text-20 text-grey-100"
        [subtext]="payload.message.subtitle" />
      <app-text class="is-flex is-justify-center is-block has-padding-normal is-word-break text-grey-100"
        [text]="payload.message.text" />
      @if (payload.message.linkText && payload.message.linkUrl) {
        <app-text [text]="payload.message.linkText"
          [url]="payload.message.linkUrl"
          class="is-flex is-justify-center has-padding-small has-margin-bottom-small is-block is-family-semiBold has-text-netatmo"
          />
      }
      @for (action of payload.actions; track action) {
        <app-button
          class="is-flex-button has-margin-bottom-small"
          [styleClass]="action.buttonConfig.styleClass"
          [text]="action.buttonConfig.text"
          (click)="onClick(action.action)" />
      }
    </app-modal-body>
    @if (payload.actions.length === 0) {
      <app-modal-footer>
        <app-text [text]="'common-settings.__CANCEL' | LANG"
          class="text-grey-50 is-cursor-pointer"
          (click)="onClick()" />
      </app-modal-footer>
    }
  </app-modal>
}

